import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=559d1c3c&scoped=true&"
var script = {}
import style0 from "@/sass/06_atoms/background.scss?vue&type=style&index=0&id=559d1c3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559d1c3c",
  null
  
)

export default component.exports